import { createBrowserHistory } from "history";

export type { Location } from "history";

export const history = createBrowserHistory();

export enum URLS {
  LOGIN = "/login",
  CREATE = "/create/*",
  HISTORY = "/history",
  HOME = "/",
}
